import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import Image from '../components/atoms/Image';
import { getImageByKey } from '../assets/Assets';
import type { ImageKey } from '../assets/Assets';

const Preview = styled.div<{
	width: number;
	height: number;
	hasPreview: boolean;
}>`
	border: 1px solid ${(props) => props.theme.colors.veryLightBlue};
	color: ${(props) => props.theme.colors.black};
	display: block;
	position: relative;
	height: ${(props) => props.height}px;
	width: ${(props) => props.width}px;
`;

const Info = styled.span`
	bottom: 0;
	padding: 0.2em;
	position: absolute;
	right: 0;
`;

const DEFAULT_WIDTH = 100;
const DEFAULT_HEIGHT = 100;
const SCREEN_WIDTH = 1920 * 0.2;
const SCREEN_HEIGHT = 1080 * 0.2;

interface ImagePreviewProps {
	imageKey?: ImageKey;
	screen?: boolean;
	info?: string;
}

const ImagePreview: FunctionComponent<ImagePreviewProps> = (
	props: ImagePreviewProps
) => {
	const { imageKey, screen = false, info } = props;

	const width = screen ? SCREEN_WIDTH : DEFAULT_WIDTH;
	const height = screen ? SCREEN_HEIGHT : DEFAULT_HEIGHT;

	return (
		<Preview width={width} height={height} hasPreview={!!imageKey}>
			{imageKey && (
				<Image src={getImageByKey(imageKey)} width={width} height={height} />
			)}
			{info && <Info>{info}</Info>}
		</Preview>
	);
};

export default ImagePreview;
